/* eslint-disable max-len */
const WHITE_DOT = 'https://firebasestorage.googleapis.com/v0/b/caresend-dev.appspot.com/o/icons%2Fwhite-dot.png?alt=media&token=449f945e-30b7-405a-8062-bb153bcad53f';

export { WHITE_DOT };
